import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'

import SignOut from '../sign-out'
import SigninFormLaunchModal from '../forms/signin-form/signin-form-launch-modal'

import './header.scss'

import THREEDMSS_LOGO from '../../images/logo/3dmss_logo.svg'
import THREEDMSS_LOGO_HOME from '../../images/logo/3dmss_logo_home.svg'

export default function Header(props) {
  return (
    <Container fluid className="w-100 header-background">
      <div className="d-flex d-md-none row mt-3 mt-md-5 mb-2 justify-content-center">
        {!props.authenticated
        && typeof window !== `undefined`
        && window.location.pathname !== '/'
        &&
          <SigninFormLaunchModal launchSignin={props.launchSignin}>
            <Button
              variant="outline-primary btn-sm"
              className="slide m-2"
            >
              Teacher Edition&nbsp; <i className="fas fa-sign-in-alt" />
            </Button>
          </SigninFormLaunchModal>
        }
        {props.authenticated
        && typeof window !== `undefined`
        && window.location.pathname !== '/'
        &&
          <SignOut signOut={props.signOut}>
            <Button
              variant="outline-primary btn-sm"
              className="slide m-2"
            >
              Sign Out&nbsp;<i className="fas fa-sign-in-alt" />
            </Button>
          </SignOut>
        }
      </div>
      <div className="d-flex d-lg-none row mt-3 mt-md-5 mb-2 justify-content-center">
        {!props.authenticated
        && typeof window !== `undefined`
        && window.location.pathname === '/'
        &&
          <SigninFormLaunchModal launchSignin={props.launchSignin}>
            <Button
              variant="outline-primary btn-sm"
              className="slide m-2"
            >
              Teacher Sign In / Registration&nbsp;<i className="fas fa-sign-in-alt" />
            </Button>
          </SigninFormLaunchModal>
        }
        {props.authenticated && typeof window !== `undefined` && window.location.pathname === '/' &&
          <SignOut signOut={props.signOut}>
            <Button
              variant="outline-primary btn-sm"
              className="slide m-2"
            >
              Sign Out&nbsp; <i className="fas fa-sign-in-alt" />
            </Button>
          </SignOut>
        }
      </div>
      {!props.authenticated
      && typeof window !== `undefined`
      && window.location.pathname !== '/'
      &&
        <hr className="d-block d-md-none" />
      }
      {!props.authenticated
      && typeof window !== `undefined`
      && window.location.pathname === '/'
      &&
        <React.Fragment>
          <hr className="d-block d-lg-none mt-4" />
            <h3 className="text-center tagline d-block d-lg-none">
              Help solve the mystery of why M'Kenna feels sick!
            </h3>
          <hr className="d-block d-lg-none mb-4" />
        </React.Fragment>
      }
      <div className="d-flex row" style={{position: 'relative'}}>
        {typeof window !== `undefined`
        && window.location.pathname === '/'
        &&
          <React.Fragment>
            <h3 className="tagline large d-none d-lg-block d-xl-none">
              Help solve the mystery of why M'Kenna feels sick!
            </h3>
            <h3 className="tagline extra-large d-none d-xl-block">
              Help solve the mystery of why M'Kenna feels sick!
            </h3>
          </React.Fragment>
        }
        <div className="p-2 flex-grow-1 logo-row">
          {typeof window !== `undefined`
          && window.location.pathname !== '/'
          &&
            <Link to="/">
              <img
                className="bscsLogo img-fluid d-none d-md-block"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "400px",
                  position: "absolute",
                  top: '18%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-none d-sm-block d-md-none"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "399px",
                  position: "absolute",
                  top: '-2%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-block d-sm-none"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "253px",
                  position: "absolute",
                  top: '35%'
                }}
              />
            </Link>
          }
          {typeof window !== `undefined`
          && window.location.pathname === '/'
          &&
            <React.Fragment>
              <img
                className="bscsLogo img-fluid d-none d-xl-block"
                src={THREEDMSS_LOGO_HOME}
                alt="A Medical Mystery logo."
                style={{
                  width: "598px",
                  position: "absolute",
                  top: '14%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-none d-lg-block d-xl-none large-home-logo"
                src={THREEDMSS_LOGO_HOME}
                alt="A Medical Mystery logo."
                style={{
                  width: "602px",
                  position: "absolute",
                  top: '13%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-none d-md-block d-lg-none"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "498px",
                  position: "absolute",
                  left: '19%',
                  top: '-2%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-none d-sm-block d-md-none"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "401px",
                  position: "absolute",
                  top: '-3%'
                }}
              />
              <img
                className="bscsLogo img-fluid d-block d-sm-none"
                src={THREEDMSS_LOGO}
                alt="A Medical Mystery logo."
                style={{
                  width: "250px",
                  position: "absolute",
                  top: '36%'
                }}
              />
            </React.Fragment>
          }
        </div>
        <div className="d-none d-md-flex p-2 mx-4 my-2 justify-content-end align-self-end">
          {!props.authenticated
          && typeof window !== `undefined`
          && window.location.pathname !== '/'
          &&
            <SigninFormLaunchModal launchSignin={props.launchSignin}>
              <Button
                variant="outline-primary btn-sm"
                className="slide m-2"
              >
                Teacher Edition&nbsp; <i className="fas fa-sign-in-alt" />
              </Button>
            </SigninFormLaunchModal>
          }
          {props.authenticated
          && typeof window !== `undefined`
          && window.location.pathname !== '/'
          &&
            <SignOut signOut={props.signOut}>
              <Button
                variant="outline-primary btn-sm"
                className="slide m-2"
              >
                Sign Out&nbsp;<i className="fas fa-sign-in-alt" />
              </Button>
            </SignOut>
          }
        </div>
        <div className="d-none d-lg-flex p-2 mx-4 my-2 justify-content-end">
          {!props.authenticated
          && typeof window !== `undefined`
          && window.location.pathname === '/'
          &&
            <SigninFormLaunchModal launchSignin={props.launchSignin}>
              <Button
                variant="outline-primary btn-sm"
                className="slide m-2"
              >
                Teacher Sign In / Registration&nbsp;<i className="fas fa-sign-in-alt" />
              </Button>
            </SigninFormLaunchModal>
          }
          {props.authenticated
          && typeof window !== `undefined`
          && window.location.pathname === '/'
          &&
            <SignOut signOut={props.signOut}>
              <Button
                variant="outline-primary btn-sm"
                className="slide m-2"
              >
                Sign Out&nbsp;<i className="fas fa-sign-in-alt" />
              </Button>
            </SignOut>
          }
        </div>
      </div>
    </Container>
  )
}

Header.propTypes = {
  authenticated: PropTypes.bool,
  location: PropTypes.object,
  signOut: PropTypes.func.isRequired,
  launchSignin: PropTypes.func.isRequired
}